const initialState = {
  data: {
    values: [
      {
        id: "d1",
        name: "الانتاجية",
        value: 75,
        history: [
          {
            date: "1-May-12",
            close: 10
          },
          {
            date: "30-Apr-12",
            close: 40
          },
          {
            date: "27-Apr-12",
            close: 60
          },
          {
            date: "26-Apr-12",
            close: 90
          }
        ]
      },
      {
        id: "d2",
        name: "القدرة الاستيعابية",
        value: 70,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 60
          }
        ]
      },
      {
        id: "d3",
        name: "مستوى الثقة ",
        value: 0,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d4",
        name: " نسبة الإشغال",
        value: 45,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d5",
        name: "استمرارية الخدمة",
        value: 80,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d6",
        name: "زمن الانتظار",
        value: 75,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d7",
        name: "زمن التقديم",
        value: 100,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d8",
        name: "زمن إنجاز الخدمة",
        value: 55,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d9",
        name: "زمن اتمام الخدمة",
        value: 35,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d10",
        name: "زمن الخدمة القياسي",
        value: 65,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d11",
        name: "مستوى سعادة المتعاملين",
        value: 85,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d12",
        name: "معدل جودة الخدمة الكلي",
        value: 15,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d13",
        name: "تكلفة الوحدة من الخدمة",
        value: 60,
        history: [
          {
            date: "1-May-12",
            close: 0
          },
          {
            date: "30-Apr-12",
            close: 30
          },
          {
            date: "27-Apr-12",
            close: 70
          },
          {
            date: "26-Apr-12",
            close: 30
          },
          {
            date: "10-Mar-12",
            close: 90
          }
        ]
      }
    ],
    itemName: "متوسط مؤشرات القطاع",
    icon: "\uf271",
    nextItem: { name: "الكيان", icon: "\uf1ec" },
    prevItem: { name: "الكيان", icon: "\uf786" }
  }
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    default:
      return state;
  }
};
